import React from 'react';
import { Route } from 'react-router-dom';
import { checkLocationTokenAndAuthorize, checkWidgetAuthorization } from './utils/check-auth';

export const PrivateRoute = ({ component: Component, store, path, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      console.log('PrivateRoute');
      const tokenAccess = checkLocationTokenAndAuthorize(store, rest);
      if (tokenAccess.access) {
        return <Component {...props} />;
      } else {
        const access = checkWidgetAuthorization(store);
        if (access.access) {
          return <Component {...props} />;
        } else {
          window.location.href = process.env.REACT_APP_ORGANIZATION;
        }
      }
    }}
  />
);
